module.exports = __webpack_public_path__ + "static/img/38.adf0122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/38.png
// module id = Kun4
// module chunks = 0